export default function Vision() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const navHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="raison-etre" className="relative bg-white py-16 sm:py-24 lg:py-32 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-5 gap-8 sm:gap-12 items-center">
          <div className="md:col-span-2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl max-w-md mx-auto md:max-w-none">
              <img
                src="https://storage.helloreaddy.io/project_files/ad5cb946-1e18-4620-bdd6-de178713466c/6ecbed7f-6cda-4e21-ac4b-9b5b1952a0f8_compressed_ChatGPT-Image-3-sept.-2026-13-h-12-min-13-s.webp"
                alt="Portrait du fondateur d'OTOROBOTS"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-gray-200 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif mb-6 sm:mb-8 opacity-30">"</div>
            
            <blockquote className="text-xl sm:text-2xl md:text-3xl font-light text-gray-800 leading-relaxed mb-8 sm:mb-12">
              La technologie doit libérer l'humain, pas l'éloigner de lui-même. C'est cette conviction qui guide chaque système que nous concevons.
            </blockquote>

            <div className="mb-8 sm:mb-12">
              <p className="text-sm sm:text-base text-gray-700 font-light mb-1">Fondateur</p>
              <p className="text-xs sm:text-sm text-gray-600 font-light">OTOROBOTS CANADA INC.</p>
            </div>

            <div className="space-y-4 sm:space-y-6 text-sm sm:text-base text-gray-700 font-light leading-relaxed">
              <p>
                OTOROBOTS CANADA INC. existe pour concevoir des ponts intelligents entre les systèmes technologiques et l'expérience humaine, afin que la technologie soutienne l'humain plutôt que de l'éloigner de lui-même.
              </p>
              <p>
                Nous croyons que l'automatisation et l'intelligence artificielle doivent libérer l'humain, et non l'éloigner de lui-même. Notre rôle est de structurer des systèmes qui clarifient, qui allègent, qui permettent à chacun de se reconnecter à ce qui est essentiel.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}